import _ from "lodash";
// import Activity from "./routes/Activity";
// import ReportCard from "./routes/ReportCard";
// import ResourceBankRoute from "./routes/ResourceBank";
// import ArchiveUnitPlans from "ArchiveUnitPlans";
// import SchedulerPlan from "./routes/SchedulerPlan";
import UnitPlans from "./routes/UnitPlans";
import ClassPlanners from "./routes/ClassPlanners";
import Scheduler from "./routes/Scheduler";
import { injectReducer } from "store/reducers";
// import SchedularTeacherPlan from "./routes/SchedularTeacherPlan";
import MYPLearningStandards from "MYPLearningStandards";
import DPLearningStandards from "DPLearningStandards";
import Journal from "./routes/Journal";
import Routines from "./routes/Routines";
import AssessmentEvaluation from "./routes/AssessmentEvaluation";
import TimetablePlanner from "TimetablePlanner";
import StudentPortfolio from "./routes/StudentPortfolio";
import ProgressReport from "./routes/ProgressReport";
import FamilyConversations from "./routes/FamilyConversations";
import UnitLibrary from "./routes/UnitLibrary";
import ClassRoom from "./routes/ClassRoom";
import ClassSettings from "./routes/ClassSettings";
import ClassNotificationSettings from "./routes/ClassNotificationSettings";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  TeacherResources,
  TeacherPolicy,
  ParentPolicy,
  StudentPolicy,
  StudentResources,
  ParentResources,
} from "OrganizationResources";
import Attendance from "./routes/Attendance";
import Circulars from "./routes/Circulars";
import PlanningInsights from "./routes/PlanningInsights";
import LELibrary from "./routes/LELibrary";
import ManageFamily from "./routes/ManageFamily";
import Projects from "Projects";
import StudentDrive from "./routes/StudentDrive";
import TimetableConfiguration from "./routes/TimetableConfiguration";
import Continuum from "Continuum";
import PracticalActivities from "./routes/PracticalActivities";
import Settings from "./routes/Settings";
import UBDLearningStandards from "UBDAcademicSetup/routes/LearningStandards";
import Gradebook from "AppComponents/Gradebook";
import ClassSettingsV2 from "./routes/ClassSettingsV2";
import SubjectSettings from "./routes/SubjectSettings";
import ClassRoomInsights from "./routes/ClassRoom/routes/ClassRoomInsights";
import RecordOfExperimentalProgrammes from "./routes/RecordOfExperimentalProgrammes";
import DocumentEditor from "./routes/DocumentEditor";
import ClassFlow from "./routes/ClassMaterials";
import CourseFlow from "CourseFlow";
import CoursePlan from "CoursePlan";
import ClassMaterials from "./routes/ClassMaterials/oldRoute";
import RecycleBin from "./routes/RecycleBin";
import CourseWorkflows from "./routes/CourseWorkflows";
import SymLinks from "Platform/routes/SymLinks";
import LtiTools from "./routes/LTITool";
import { CircularRoutes } from "Administrator/routes";
import Home from "Teacher/routes/LearningCourse/routes/Home";

export default store => ({
  path: ":course_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "teacher-course" */ "./components"),
        import(
          /* webpackChunkName: "teacher-course" */ "Circulars/modules/CircularsModule"
        ),
        import(
          /* webpackChunkName: "teacher-course" */ "Course/modules/CourseModule"
        ),
        import(
          /* webpackChunkName: "learning-course" */ "LearningCourse/modules/LearningCourseModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const module1 = importedModule1;
          const module2 = importedModule2;
          const module3 = importedModule3;
          injectReducer(store, {
            key: module1.NAME,
            reducer: module1.default,
          });
          injectReducer(store, {
            key: module2.NAME,
            reducer: module2.default,
          });
          injectReducer(store, {
            key: module3.NAME,
            reducer: module3.default,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    SymLinks(store),
    // Activity(store),
    // SchedulerPlan(store),
    // SchedularTeacherPlan(store),
    // ReportCard(store),
    // ResourceBankRoute(store),
    // ArchiveUnitPlans(store),
    //EducatorCenter(store),
    UnitPlans(store),
    Settings(store),
    ClassRoom(store),
    StudentPortfolio(store),
    ..._.map(CircularRoutes, comp => comp(store)),
    // class-materials was replaced by class-flow
    // the old routes are only placed for redirection and will be deleted soon
    ClassMaterials(store),
    ClassFlow(store),
    TimetablePlanner(store),
    CourseFlow(store),
    CoursePlan(store),
    Home(store),
    ClassPlanners(store),
    DocumentEditor(store),
    Scheduler(store),
    Journal(store),
    FamilyConversations(store),
    AssessmentEvaluation(store),
    ProgressReport(store),
    UnitLibrary(store),
    LELibrary(store),
    Attendance(store),
    TeacherResources(store),
    TeacherPolicy(store),
    ParentPolicy(store),
    Circulars(store),
    ClassSettings(store),
    ClassNotificationSettings(store),
    PlanningInsights(store),
    DPLearningStandards(store),
    MYPLearningStandards(store),
    UBDLearningStandards(store),
    ManageFamily(store),
    Projects(store),
    StudentDrive(store),
    TimetableConfiguration(store),
    Continuum(store),
    PracticalActivities(store),
    RecordOfExperimentalProgrammes(store),
    Gradebook(store),
    ClassSettingsV2(store),
    SubjectSettings(store),
    ClassRoomInsights(store),
    StudentResources(store),
    ParentResources(store),
    StudentPolicy(store),
    RecycleBin(store),
    Routines(store),
    LtiTools(store),
    CourseWorkflows(store),
  ],
});
